<div class="row">
    <div class="col-lg-12">
        <h2>Afl&#259; ce po&#539;i face &#238;n magazinele Orange</h2>
        <p>Vino &#238;n magazinele Orange unde echipa noastr&#259; &#238;&#539;i va acorda asisten&#539;a de care ai nevoie pentru telefonul t&#259;u &#351;i te va pune la curent cu ultimele nout&#259;&#539;i din magazine</p>
    </div>
</div>
<div class="row">
    <div class="caseta-serv col-lg-3 col-md-3 col-sm-6 col-xs-122">
        <a href="https://www.orange.ro/shop-locator/asistenta-in-magazin/"><img src="assets/box/asistenta-hp.png" alt="Asisten&#539;&#259; &#238;n magazin" class="img-responsive"></a>
        <div class="descriere bg-gri ">
            <h3><a href="/oferta-senior">Asisten&#539;&#259;<br>
                &#238;n magazin </a></h3>
            <p class="mh150"> Te ajut&#259;m s&#259; &#238;&#539;i configurezi telefonul, iar dac&#259; ai nevoie, po&#539;i afla unde &#238;&#539;i po&#539;i repara telefonul pe loc. </p>
            <p class="cta"><a class="btn" href="https://www.orange.ro/shop-locator/asistenta-in-magazin/">Mai multe</a></p>
        </div>
    </div>
    <div class="caseta-serv col-lg-3 col-md-3 col-sm-6 col-xs-122">
        <a href="/echipa-noastra"><img src="assets/box/team.png" alt="Asisten&#539;&#259; &#238;n magazin " class="img-responsive"></a>
        <div class="descriere bg-gri ">
            <h3><a href="https://www.orange.ro/shop-locator/echipa-noastra/">Echipa <br>
                noastr&#259; </a></h3>
            <p class="mh150">&#238;&#539;i oferim consultan&#539;&#259; pentru produsele &#351;i serviciile Orange. &#238;n plus, te po&#539;i programa pentru o vizit&#259; &#238;n magazin.
            </p>
            <p class="cta"><a class="btn" href="https://www.orange.ro/shop-locator/echipa-noastra/">Mai multe</a></p>
        </div>
    </div>
    <div class="caseta-serv col-lg-3 col-md-3 col-sm-6 col-xs-122">
        <a href="https://www.orange.ro/shop-locator/informatii-utile/"><img src="assets/box/info.png" alt="Asisten&#539;&#259; &#238;n magazin " class="img-responsive"></a>
        <div class="descriere bg-gri ">
            <h3><a href="https://www.orange.ro/shop-locator/informatii-utile/">Informa&#539;ii <br>
                utile </a></h3>
            <p class="mh150">Afl&#259; nout&#259;&#539;ile din magazine, ofertele speciale, detalii despre programul Buy-Back sau plata &#238;n rate.
            </p>
            <p class="cta"><a class="btn" href="/informatii-utile">Mai multe</a></p>
        </div>
    </div>
    <div class="caseta-serv col-lg-3 col-md-3 col-sm-6 col-xs-122">
        <a href="https://www.orange.ro/shop-locator/"><img src="assets/box/bill.png" alt="Pl&#259;&#539;i facturi " class="img-responsive"></a>
        <div class="descriere bg-gri ">
            <h3><a href="/plati-facturi">Pl&#259;&#539;i <br>
                facturi </a></h3>
            <p class="mh150"> Afl&#259; cum &#351;i unde po&#539;i pl&#259;ti factura Orange sau facturile de utilit&#259;&#539;i.
            </p>
            <p class="cta"><a class="btn" href="https://www.orange.ro/shop-locator/">Mai multe</a></p>
        </div>
    </div>
</div>